import { assertEvent } from 'xstate';
import { type GuardArgs } from 'xstate/guards';

import { checkIfBagFeaturedUpsellSessionEligible } from '../../storage';
import { type BagFeaturedUpsellContext } from './bag-featured-upsell.machine.context';
import { type BagFeaturedUpsellEvent } from './bag-featured-upsell.machine.events';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfEligible(guardArgs: Args) {
  const { canShowUpsells, sessionInterval } = guardArgs.context;

  return canShowUpsells && checkIfBagFeaturedUpsellSessionEligible(sessionInterval);
}

export function checkIfCanOfferProduct(guardArgs: Args) {
  const { product, cartProductIds } = guardArgs.context;

  const isProductInBag = Boolean(product && cartProductIds.includes(product.id));

  return Boolean(product) && !isProductInBag;
}

export function checkIfProductAdded(guardArgs: Args) {
  const { event } = guardArgs;

  assertEvent(event, 'ADD_FINISHED');

  return event.isProductInBag;
}

export function checkIfCanAnimate(guardArgs: Args) {
  const { hasAnimationImage, isReduceMotionEnabled } = guardArgs.context;

  return hasAnimationImage && !isReduceMotionEnabled;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Args = GuardArgs<BagFeaturedUpsellContext, BagFeaturedUpsellEvent>;
